<template>
  <div class="priceManagement-page">
    <div class="all-content-container">
      <div class="screen-all-container">
        <el-tabs v-model="activeName2" class="el-tab_top">
          <el-tab-pane label="分组" name="first" style="margin-right: 30px">
            <groupManagement></groupManagement>
          </el-tab-pane>
          <el-tab-pane label="设备" name="second">
            <equipmentManagement :message="activeName3"></equipmentManagement>
          </el-tab-pane>
          <el-tab-pane label="环境模型" name="third">
            <hj></hj>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import groupManagement from '../deviceManagement/groupManagement'
import equipmentManagement from '../deviceManagement/equipmentManagement'
import hj from '../deviceManagement/hj'

export default {
  components: {
    groupManagement,
    equipmentManagement,
    hj
  },
  data() {
    return {
      activeName2: 'first',
      activeName3: 'first'
    }
  },
  created() {
    if (this.$route.query.currentShow != null) {
      this.activeName2 = this.$route.query.currentShow
    }
    if (this.$route.query.currentShow == 'second') {
      this.activeName3 = this.$route.query.currentShow1
    }
  },
  methods: {
    handleSelect() {},
    show(id) {
      this.activeIndex = id
    }
  }
}
</script>
<style scoped>
@import '../../style/userManagement.scss';
</style>